import React from 'react';
import { StyledFrontpageStage } from './frontpage-stage.style';

interface IProps {
    children?: any;
    backgroundImage: string;
}

export const FrontpageStage: React.FunctionComponent<IProps> = (props) => {
    const { backgroundImage, children } = props;

    return (
        <StyledFrontpageStage data-testid="frontpage-stage" background={backgroundImage}>
            {children}
        </StyledFrontpageStage>
    );
};
